"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentlyViewed = void 0;
var recently_viewed_1 = require("./recently-viewed");
Object.defineProperty(exports, "RecentlyViewed", { enumerable: true, get: function () { return recently_viewed_1.RecentlyViewed; } });
